import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdministrationRoutingModule } from './administration-routing.module';
import { MasterProductsComponent } from './components/master-products/master-products.component';
import { MasterDataManagementComponent } from './components/master-data-management/master-data-management.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { StorageService } from '../Common/services/storage.service';
import { MasterStoresComponent } from './components/master-stores/master-stores.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { MasterMaterialComponent } from './components/master-material/master-material.component';
import { AccessManagementComponent } from './components/access-management/access-management.component';
import { MasterFileUploadComponent } from './components/master-file-upload/master-file-upload.component';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RoleDisplayPipe } from './pipes/role-display.pipe';
import { MasterDataSetupComponent } from './components/master-data-setup/master-data-setup.component';


@NgModule({
  declarations: [
    MasterProductsComponent,
    MasterDataManagementComponent,
    MasterStoresComponent,
    MasterMaterialComponent,
    AccessManagementComponent,
    MasterFileUploadComponent,
    RoleDisplayPipe,
    MasterDataSetupComponent
  ],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DropdownModule,
    CheckboxModule,
    MultiSelectModule,
    RadioButtonModule,
    ConfirmDialogModule
  ]
})
export class AdministrationModule { }
